let firstKey = null;
let firstKeyTimer = null;
let feedbackEl = null;

const sequences = {
  'g+h': () => window.location.href = '/',
  'g+o': () => window.location.href = '/orders',
  'g+d': () => window.location.href = '/documents',
  'g+c': () => window.location.href = '/clients',
  'g+r': () => window.location.href = '/requests',
};

const adminSequences = {
  'g+q': () => window.location.href = '/orders/queues',
  'g+b': () => window.location.href = '/batches',
  'g+p': () => window.location.href = '/documents/pickup_package',
  'g+n': () => window.location.href = '/documents/return_package',
  'g+s': () => window.location.href = '/services/new?service=ind',
  'g+z': () => window.location.href = '/positions',
};

function activeSequences() {
  const isAdmin = document.body.dataset.admin === 'true';
  return isAdmin ? { ...sequences, ...adminSequences } : sequences;
}

const helpRows = [
  ['g h', 'Hlavní stránka'],
  ['g o', 'Objednávky'],
  ['g d', 'Doklady'],
  ['g c', 'Klienti / nastavení'],
  ['g r', 'Požadavky'],
];

const adminHelpRows = [
  ['g q', 'Fronty objednávek'],
  ['g b', 'Přepravy (batches)'],
  ['g p', 'Osobní odběr'],
  ['g n', 'Nevyzvednutá zásilka'],
  ['g s', 'Placená podpora'],
  ['g z', 'Pozice'],
];

function showFeedback(text) {
  if (!feedbackEl) {
    feedbackEl = document.createElement('div');
    feedbackEl.style.cssText = [
      'position:fixed', 'bottom:1rem', 'right:1rem',
      'background:#333', 'color:#fff',
      'padding:.3rem .7rem', 'border-radius:6px',
      'font-family:monospace', 'font-size:1rem',
      'pointer-events:none', 'z-index:9999',
      'transition:opacity .15s',
    ].join(';');
    document.body.appendChild(feedbackEl);
  }
  feedbackEl.textContent = text;
  feedbackEl.style.opacity = '1';
}

function hideFeedback() {
  if (feedbackEl) feedbackEl.style.opacity = '0';
}

function buildHelpTable(rows) {
  return rows.map(([seq, label]) =>
    `<tr><td style="padding:.2rem .8rem .2rem 0"><kbd>${seq.replace(' ', '</kbd> <kbd>')}</kbd></td><td>${label}</td></tr>`
  ).join('');
}

function showHelp() {
  const isAdmin = document.body.dataset.admin === 'true';
  const modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:9999';
  modal.innerHTML = `
    <div style="background:#fff;padding:2rem;border-radius:8px;min-width:260px">
      <strong>Klávesové zkratky</strong>
      <table style="margin-top:1rem;border-collapse:collapse">
        ${buildHelpTable(helpRows)}
        ${isAdmin ? buildHelpTable(adminHelpRows) : ''}
        <tr><td style="padding:.2rem .8rem .2rem 0"><kbd>?</kbd></td><td>Tato nápověda</td></tr>
      </table>
      <small style="display:block;margin-top:1rem;color:#888">Klikni kamkoliv pro zavření</small>
    </div>
  `;
  modal.addEventListener('click', () => modal.remove());
  document.addEventListener('keydown', () => modal.remove(), { once: true });
  document.body.appendChild(modal);
}

document.addEventListener('turbolinks:load', function () {
  firstKey = null;
  clearTimeout(firstKeyTimer);
  feedbackEl = null;
});

document.addEventListener('keydown', function (e) {
  if (e.target.matches('input, textarea, select, [contenteditable]')) return;
  if (e.metaKey || e.ctrlKey || e.altKey) return;

  const key = e.key.toLowerCase();

  if (key === '?') {
    showHelp();
    return;
  }

  if (firstKey) {
    const sequence = `${firstKey}+${key}`;
    const handler = activeSequences()[sequence];

    clearTimeout(firstKeyTimer);
    firstKey = null;
    hideFeedback();

    if (handler) {
      e.preventDefault();
      handler();
    }
  } else {
    firstKey = key;
    showFeedback(`${key} →`);
    firstKeyTimer = setTimeout(() => {
      firstKey = null;
      hideFeedback();
    }, 1000);
  }
});
